import { defineComponent as _defineComponent } from 'vue'
import { ref, computed} from "vue";
import emitter from "../../events";
import { MainSidebar } from "@busy-human/vue-component-library";


export default /*@__PURE__*/_defineComponent({
  __name: 'app-main-sidebar',
  setup(__props, { expose: __expose }) {
  __expose();

const compactMode = ref(false);
const fixedSlide = ref(false);
const useSlide = ref(false);


emitter.on('fixedSlideMode', ()=>{
	fixedSlide.value = !fixedSlide.value;
	if(!useSlide.value){
		useSlide.value = true;
	}
});

emitter.on('compactMode', ()=>{
	compactMode.value = !compactMode.value;
});

emitter.on('useSlide', ()=>{
	useSlide.value = !useSlide.value;
});

const __returned__ = { compactMode, fixedSlide, useSlide, ref, computed, get emitter() { return emitter }, get MainSidebar() { return MainSidebar } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})